var paragraph_default = {
  "fontElementMap": "_50j1f",
  "elementSpacing": "UGrRC",
  "text": "e3Vej UGrRC",
  "child": "eKaei"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
